// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.looknfeel-main {
  height: calc(100vh - 60px);
  overflow-y: scroll;
  overflow-x: hidden;
}
.color-white {
  color: white !important;
}

/* nav */
.genes-navbar-brand {
  max-width: 130px;
}
.btn-fill {
  background-color: #26e5c6 !important;
  border: none !important;
  font-weight: 600 !important;
  color: rgb(55, 55, 55) !important;
}
.btn-fill:hover {
  background-color: #00dab6 !important;
  font-weight: 600 !important;
}
.btn-fill:active {
  background-color: #00dab6 !important;
  border: none;
  font-weight: 600 !important;
}
.btn-bordered {
  box-shadow: inset 0px 0px 0px 2px #26e5c6;
  font-weight: 600 !important;
  color: rgb(55, 55, 55) !important;
}
.btn-bordered:hover {
  box-shadow: inset 0px 0px 0px 5px #00dab6;
  font-weight: 600 !important;
}

/* header */
.bg-header {
  background-color: #7a6be8;
}
.text-header {
  font-size: 22px;
}

/* diferenciales boxes */

.yellow-line {
  left: 0px;
  height: 25px;
  width: 100%;
  background-color: #ffc107;
  border-radius: 0px 10px 10px 0px;
}

.diferenciales-boxes {
  width: 100%;
  height: 200px;
  background-color: #f5eaff;
  border-radius: 10px;
  display: flex;
  float: left;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center !important;
  color: #251448;
  text-align: center;
  font-weight: bold;
  padding: 15px;
  margin-bottom: 20px;
  box-shadow: 10px 11px 12px -10px rgb(0 0 0 / 75%);
}
.diferenciales-boxes p {
  padding-top: 15px;
  font-weight: bold;
}

.diferencial-big-box {
  width: 100%;
  height: 420px;
  background-color: #f5eaff;
  border-radius: 10px;
  color: #251448;
  display: flex;
  float: left;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  text-align: center;
  padding: 25px;
  margin-bottom: 20px;
  box-shadow: 10px 11px 12px -10px rgb(0 0 0 / 75%);
}

.diferencial-big-box p {
  font-weight: bold;
  padding-top: 15px;
}

.diferenciales-boxes-hover {
  width: 93%;
  color: #fff;
  opacity: 0;
  transition: all 0.5s ease;
  background-color: #a07eb7;
  position: absolute;
  border-radius: 10px;
}
.diferenciales-boxes .diferenciales-boxes-hover {
  height: 200px;
}
.diferencial-big-box .diferenciales-boxes-hover {
  height: 420px;
}
.diferenciales-boxes:hover .diferenciales-boxes-hover,
.diferencial-big-box:hover .diferenciales-boxes-hover {
  opacity: 0.9;
}
.diferenciales-boxes a,
.diferencial-big-box a {
  color: rgba(255, 255, 255, 1);
  padding: 2px 22px;
  border: 2px solid rgba(255, 255, 255, 1);
  transition: all 0.5s ease-in-out;
  position: relative;
  border-radius: 10px;
  top: 90px;
}

/* carousel */
.carousel-logo {
  text-align: center;
  margin-bottom: 15px;
  width: 100%;
  height: 100px;
  background-color: transparent;
}
.carousel-indicators {
  margin-bottom: 0 !important;
}
.carousel-indicators button {
  border-radius: 50%;
  padding: 10px !important;
  width: 4px !important;
  background-color: #251448 !important;
}

/* solicita interfaz */

.box-img img {
  margin-bottom: 15px;
  width: 100%;
  background-color: #b2a5cc;
  box-shadow: 10px 11px 12px -10px rgb(0 0 0 / 75%);
}

/* colaboradores faixa */
.colaboradores-faixa {
  padding: 48px 0;
  margin-right: -15px;
  margin-left: -15px;
  text-align: center;
  background: #9176b2;
  background: linear-gradient(45deg, #9176b2 0%, #bca5cd 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#9176b2', endColorstr='#bca5cd',GradientType=1 );
}
.colaboradores-faixa p {
  font-size: 28px;
  line-height: 46px;
  position: relative;
}
.colaboradores-faixa p:before {
  content: " “ ";
  position: absolute;
  left: 0px;
  top: 60px;
  font-size: 320px;
  opacity: 0.3;
}

/* end page */

.end-page {
  color: #5f509e;
  font-size: 44px;
}
`, "",{"version":3,"sources":["webpack://./src/Views/LooknFeel/Genes/styles.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,uBAAuB;AACzB;;AAEA,QAAQ;AACR;EACE,gBAAgB;AAClB;AACA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,2BAA2B;EAC3B,iCAAiC;AACnC;AACA;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;AACA;EACE,oCAAoC;EACpC,YAAY;EACZ,2BAA2B;AAC7B;AACA;EAGE,yCAAyC;EACzC,2BAA2B;EAC3B,iCAAiC;AACnC;AACA;EAGE,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA,WAAW;AACX;EACE,yBAAyB;AAC3B;AACA;EACE,eAAe;AACjB;;AAEA,wBAAwB;;AAExB;EACE,SAAS;EACT,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,6BAA6B;EAC7B,8BAA8B;EAC9B,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,iDAAiD;AACnD;AACA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EAGnB,iDAAiD;AACnD;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,UAAU;EAIV,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;;EAEE,YAAY;AACd;AACA;;EAEE,6BAA6B;EAC7B,iBAAiB;EACjB,wCAAwC;EAIxC,gCAAgC;EAChC,kBAAkB;EAClB,mBAAmB;EACnB,SAAS;AACX;;AAEA,aAAa;AACb;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,6BAA6B;AAC/B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA,sBAAsB;;AAEtB;EACE,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EAGzB,iDAAiD;AACnD;;AAEA,wBAAwB;AACxB;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EAGnB,4DAA4D;EAC5D,mHAAmH;AACrH;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,gBAAgB;EAChB,YAAY;AACd;;AAEA,aAAa;;AAEb;EACE,cAAc;EACd,eAAe;AACjB","sourcesContent":[".looknfeel-main {\n  height: calc(100vh - 60px);\n  overflow-y: scroll;\n  overflow-x: hidden;\n}\n.color-white {\n  color: white !important;\n}\n\n/* nav */\n.genes-navbar-brand {\n  max-width: 130px;\n}\n.btn-fill {\n  background-color: #26e5c6 !important;\n  border: none !important;\n  font-weight: 600 !important;\n  color: rgb(55, 55, 55) !important;\n}\n.btn-fill:hover {\n  background-color: #00dab6 !important;\n  font-weight: 600 !important;\n}\n.btn-fill:active {\n  background-color: #00dab6 !important;\n  border: none;\n  font-weight: 600 !important;\n}\n.btn-bordered {\n  -webkit-box-shadow: inset 0px 0px 0px 2px #26e5c6;\n  -moz-box-shadow: inset 0px 0px 0px 2px #26e5c6;\n  box-shadow: inset 0px 0px 0px 2px #26e5c6;\n  font-weight: 600 !important;\n  color: rgb(55, 55, 55) !important;\n}\n.btn-bordered:hover {\n  -webkit-box-shadow: inset 0px 0px 0px 5px #00dab6;\n  -moz-box-shadow: inset 0px 0px 0px 5px #00dab6;\n  box-shadow: inset 0px 0px 0px 5px #00dab6;\n  font-weight: 600 !important;\n}\n\n/* header */\n.bg-header {\n  background-color: #7a6be8;\n}\n.text-header {\n  font-size: 22px;\n}\n\n/* diferenciales boxes */\n\n.yellow-line {\n  left: 0px;\n  height: 25px;\n  width: 100%;\n  background-color: #ffc107;\n  border-radius: 0px 10px 10px 0px;\n}\n\n.diferenciales-boxes {\n  width: 100%;\n  height: 200px;\n  background-color: #f5eaff;\n  border-radius: 10px;\n  display: flex;\n  float: left;\n  flex-direction: column;\n  justify-content: space-evenly;\n  align-items: center !important;\n  color: #251448;\n  text-align: center;\n  font-weight: bold;\n  padding: 15px;\n  margin-bottom: 20px;\n  box-shadow: 10px 11px 12px -10px rgb(0 0 0 / 75%);\n}\n.diferenciales-boxes p {\n  padding-top: 15px;\n  font-weight: bold;\n}\n\n.diferencial-big-box {\n  width: 100%;\n  height: 420px;\n  background-color: #f5eaff;\n  border-radius: 10px;\n  color: #251448;\n  display: flex;\n  float: left;\n  flex-direction: column;\n  justify-content: space-evenly;\n  align-items: center;\n  text-align: center;\n  padding: 25px;\n  margin-bottom: 20px;\n  -webkit-box-shadow: 10px 11px 12px -10px rgb(0 0 0 / 75%);\n  -moz-box-shadow: 10px 11px 12px -10px rgba(0, 0, 0, 0.75);\n  box-shadow: 10px 11px 12px -10px rgb(0 0 0 / 75%);\n}\n\n.diferencial-big-box p {\n  font-weight: bold;\n  padding-top: 15px;\n}\n\n.diferenciales-boxes-hover {\n  width: 93%;\n  color: #fff;\n  opacity: 0;\n  -webkit-transition: all 0.5s ease;\n  -moz-transition: all 0.5s ease;\n  -o-transition: all 0.5s ease;\n  transition: all 0.5s ease;\n  background-color: #a07eb7;\n  position: absolute;\n  border-radius: 10px;\n}\n.diferenciales-boxes .diferenciales-boxes-hover {\n  height: 200px;\n}\n.diferencial-big-box .diferenciales-boxes-hover {\n  height: 420px;\n}\n.diferenciales-boxes:hover .diferenciales-boxes-hover,\n.diferencial-big-box:hover .diferenciales-boxes-hover {\n  opacity: 0.9;\n}\n.diferenciales-boxes a,\n.diferencial-big-box a {\n  color: rgba(255, 255, 255, 1);\n  padding: 2px 22px;\n  border: 2px solid rgba(255, 255, 255, 1);\n  -webkit-transition: all 0.5s ease-in-out;\n  -moz-transition: all 0.5s ease-in-out;\n  -o-transition: all 0.5s ease-in-out;\n  transition: all 0.5s ease-in-out;\n  position: relative;\n  border-radius: 10px;\n  top: 90px;\n}\n\n/* carousel */\n.carousel-logo {\n  text-align: center;\n  margin-bottom: 15px;\n  width: 100%;\n  height: 100px;\n  background-color: transparent;\n}\n.carousel-indicators {\n  margin-bottom: 0 !important;\n}\n.carousel-indicators button {\n  border-radius: 50%;\n  padding: 10px !important;\n  width: 4px !important;\n  background-color: #251448 !important;\n}\n\n/* solicita interfaz */\n\n.box-img img {\n  margin-bottom: 15px;\n  width: 100%;\n  background-color: #b2a5cc;\n  -webkit-box-shadow: 10px 11px 12px -10px rgb(0 0 0 / 75%);\n  -moz-box-shadow: 10px 11px 12px -10px rgba(0, 0, 0, 0.75);\n  box-shadow: 10px 11px 12px -10px rgb(0 0 0 / 75%);\n}\n\n/* colaboradores faixa */\n.colaboradores-faixa {\n  padding: 48px 0;\n  margin-right: -15px;\n  margin-left: -15px;\n  text-align: center;\n  background: #9176b2;\n  background: -moz-linear-gradient(45deg, #9176b2 0%, #bca5cd 100%);\n  background: -webkit-linear-gradient(45deg, #9176b2 0%, #bca5cd 100%);\n  background: linear-gradient(45deg, #9176b2 0%, #bca5cd 100%);\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#9176b2', endColorstr='#bca5cd',GradientType=1 );\n}\n.colaboradores-faixa p {\n  font-size: 28px;\n  line-height: 46px;\n  position: relative;\n}\n.colaboradores-faixa p:before {\n  content: \" “ \";\n  position: absolute;\n  left: 0px;\n  top: 60px;\n  font-size: 320px;\n  opacity: 0.3;\n}\n\n/* end page */\n\n.end-page {\n  color: #5f509e;\n  font-size: 44px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
